// import { IconButton } from '@affine/component';
import { AffineErrorBoundary } from '@affine/core/components/affine/affine-error-boundary';
// import { RightSidebarIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { Suspense, useCallback, useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { AppSidebarService } from '../../app-sidebar';
// import { SidebarSwitch } from '../../app-sidebar/views/sidebar-header';
import { ViewService } from '../services/view';
import { WorkbenchService } from '../services/workbench';
import * as styles from './route-container.css';
import { useViewPosition } from './use-view-position';
import { ViewBodyTarget, ViewHeaderTarget } from './view-islands';
import track from '@affine/track';

export interface Props {
  route: {
    Component: React.ComponentType;
  };
}

export const ToggleButton = ({
  onToggle,
  className,
  show,
}: {
  onToggle?: () => void;
  className: string;
  show: boolean;
}) => {
  return (
    <div
      onClick={onToggle}
      className={`${styles.chatToggleButton} ${className}`}
      style={{
        display: `${show ? 'flex' : 'none'}`,
      }}
    >
      <div className={`${styles.chatToggleButtonLeft}`}>
        <img
          className={styles.chatToggleButtonImage}
          src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/inProgressIcon.webp"
          alt="muset chat icon"
        />
      </div>
      <div className={`${styles.chatToggleButtonRight}`}>Chat</div>
    </div>
  );
  // ) : null;
  // 原始右侧边栏按钮
  // <IconButton
  //   size="24"
  //   onClick={onToggle}
  //   className={className}
  //   data-show={show}
  //   data-testid="right-sidebar-toggle"
  // >
  //   <RightSidebarIcon />
  // </IconButton>
};

export const RouteContainer = () => {
  const viewPosition = useViewPosition();
  const appSidebarService = useService(AppSidebarService).sidebar;
  const leftSidebarOpen = useLiveData(appSidebarService.open$);
  const workbench = useService(WorkbenchService).workbench;
  const view = useService(ViewService).view;
  const location = useLiveData(view.location$);
  const sidebarOpen = useLiveData(workbench.sidebarOpen$);
  const handleToggleSidebar = useCallback(() => {
    track.workspace.sidebar.$.chat_item_click({
      click_event: 'show_chat',
    });
    workbench.toggleSidebar();
  }, [workbench]);

  const showSwitch = !BUILD_CONFIG.isElectron && viewPosition.isFirst;
  const isAllPage = useMemo(() => {
    return (
      location.pathname.split('/').includes('all') ||
      location.pathname.split('/').includes('home')
    );
  }, [location.pathname]);
  const isTrashPage = useMemo(() => {
    return location.pathname.split('/').includes('trash');
  }, [location.pathname]);
  useEffect(() => {
    const preloadImage = new Image();
    preloadImage.src =
      'https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/chatSideBar.webp';
  }, []);
  return (
    <div className={`${styles.root} ${isAllPage ? styles.isAllPage : ''}`}>
      <div
        className={`${styles.header} ${isAllPage ? styles.isAllPage_header : ''}`}
        data-show-switch={showSwitch && !leftSidebarOpen}
      >
        {/* {showSwitch && (
          <SidebarSwitch
            show={!leftSidebarOpen}
            className={styles.leftSidebarButton}
          />
        )} */}
        <ViewHeaderTarget
          viewId={view.id}
          className={styles.viewHeaderContainer}
        />
        {!BUILD_CONFIG.isElectron && viewPosition.isLast && (
          <ToggleButton
            show={!sidebarOpen && !isTrashPage}
            className={styles.rightSidebarButton}
            onToggle={handleToggleSidebar}
          />
        )}
      </div>

      <AffineErrorBoundary>
        <Suspense>
          <Outlet />
        </Suspense>
      </AffineErrorBoundary>
      <ViewBodyTarget viewId={view.id} className={styles.viewBodyContainer} />
    </div>
  );
};
